<template>
	<div>
		<div id="tabs" class="container">
  
		    <div class="tabs">
		        <a v-on:click="activetab='1'" v-bind:class="[ activetab === '1' ? 'active' : '' ]">Director Details (OPC)</a>
		        <a v-on:click="activetab='2'" v-bind:class="[ activetab === '2' ? 'active' : '' ]">Nominee Details (OPC)</a>
		        <a v-on:click="activetab='3'" v-bind:class="[ activetab === '3' ? 'active' : '' ]">Other Details (OPC)</a>
		    </div>

		    <div class="content">
		        <div v-if="activetab ==='1'" class="tabcontent">
	              <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Name (in full)</p>
                            <p class="ans_label">{{prop_owners.name}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Father’s Name (in full)</p>
                            <p class="ans_label">{{prop_owners.father_name}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Mobile Number</p>
                            <p class="ans_label">{{prop_owners.mobile_no}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Email ID</p>
                            <p class="ans_label">{{prop_owners.email_id}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Date of Birth</p>
                            <p class="ans_label">{{prop_owners.dob | FormatDate('DD-MM-YYYY')}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Highest Educational Qualification</p>
                            <p class="ans_label">{{prop_owners.higest_education}}</p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Occupation</p>
                            <p class="ans_label">{{prop_owners.occupation}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">PAN Number</p>
                            <p class="ans_label">{{prop_owners.pan_number}} </p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Address</p>
                            <p class="ans_label">{{prop_owners.address}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Address Proof</p>
                            <p class="ans_label">Address.pdf <span><a :href="prop_owners.address_url" download><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">

                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">PAN (Self-Attested)</p>
                            <p class="ans_label">PAN.pdf <span><a :href="prop_owners.pan_url"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Aadhar (Self-Attested)</p>
                            <p class="ans_label">Aadhar.pdf <span><a :href="prop_owners.aadhar_url"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">

                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Passport size photo</p>
                            <p class="ans_label">Passport.pdf <span><a :href="prop_owners.passport_size_photo"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left border-seperator"></div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Do you have Digital Signature Certificate?</p>
                            <p class="ans_label">{{prop_owners.dsc}}</p>
                        </div>
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Do you have Director Identification Number (DIN)?</p>
                            <p class="ans_label">{{prop_owners.din}} <span v-if="prop_owners.din=='yes'">{{prop_owners.din_other}}</span></p>
                        </div>
                    </div>
                    <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Are you an Indian citizen?</p>
                            <p class="ans_label">{{prop_owners.citizen_of_india=='yes' ? 'India' : prop_owners.citizen_of_india_other}}</p>
                        </div>
                        <!-- <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Ownership percentage</p>
                            <p class="ans_label">{{prop_owners.ownership_percentage}}</p>
                        </div> -->
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Do you have an interest in any other entity?</p>
                            <p class="ans_label">{{prop_owners.intrested_in_other_entity}}</p>
                        </div>
                    </div>
                    <!-- <div class="col-md-12 p-l-r-0 f-left">
                        <div class="form-group col-md-6  f-left">
                            <p class="qustion_label">Interest in any other entity?</p>
                            <p class="ans_label">{{prop_owners.intrested_in_other_entity}}</p>
                        </div>
                    </div> -->
                    <div v-if="prop_owners.intrested_in_other_entity=='yes'">
                        <div class="col-md-12 p-l-r-0 f-left sub-text">
                            <span>Nature of interest (owner/partner/director etc.)</span>
                        </div>
                        <div class="col-md-12 f-left nature_interest_box" v-for="interest in prop_owners.nature_interest_list" :key="interest.id">
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6  f-left">
                                    <p class="qustion_label">Name of the Entity</p>
                                    <p class="ans_label">{{interest.entity_name}}</p>
                                </div>
                                <div class="form-group col-md-6  f-left" style="padding-left: 0px!important;padding-right: 0!important">
                                    <p class="qustion_label">Nature of Interest owner/partner/director etc.</p>
                                    <p class="ans_label">{{interest.nature_interest_interest}}</p>
                                </div>
                            </div>
                            <div class="col-md-12 p-l-r-0 f-left">
                                <div class="form-group col-md-6  f-left">
                                    <p class="qustion_label">Value in INR</p>
                                    <p class="ans_label">{{interest.value}}</p>
                                </div>
                                <div class="form-group col-md-6  f-left" style="padding-left: 0px!important;padding-right: 0!important">
                                    <p class="qustion_label">Date</p>
                                    <p class="ans_label">{{interest.date | FormatDate('DD-MM-YYYY')}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
		        </div>
		        <div v-if="activetab ==='2'" class="tabcontent">
		            <div class="col-md-12 p-l-r-0 f-left">
						<div class="form-group col-md-6  f-left">
							<p class="qustion_label">Name (in full)</p>
	            			<p class="ans_label">{{prop_nominee.name}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Father’s Name (in full)</p>
	            			<p class="ans_label">{{prop_nominee.father_name}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Mobile Number</p>
	            			<p class="ans_label">{{prop_nominee.mobile_no}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Email ID</p>
	            			<p class="ans_label">{{prop_nominee.email_id}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Date of Birth</p>
	            			<p class="ans_label">{{prop_nominee.dob | FormatDate('DD-MM-YYYY')}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Highest Educational Qualification</p>
	            			<p class="ans_label">{{prop_nominee.higest_education}}</p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Occupation</p>
	            			<p class="ans_label">{{prop_nominee.occupation}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">PAN Number</p>
	            			<p class="ans_label">{{prop_nominee.pan_number}} </p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Address</p>
	            			<p class="ans_label">{{prop_nominee.address}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Address Proof</p>
	            			<p class="ans_label">Address.pdf <span><a :href="prop_nominee.address_proff" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">PAN (Self-Attested)</p>
	            			<p class="ans_label">PAN.pdf <span><a :href="prop_nominee.pan_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Aadhar (Self-Attested)</p>
	            			<p class="ans_label">Aadhar.pdf <span><a :href="prop_nominee.aadhar_url" target="_blank"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Passport size photo</p>
	            			<p class="ans_label">Passport.pdf <span><a :href="prop_nominee.passport_size_photo"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left border-seperator"></div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Are you an Indian citizen?</p>
	            			<p class="ans_label">{{prop_nominee.citizen_of_india}}  <span v-if="prop_nominee.citizen_of_india=='no'">{{prop_nominee.citizen_of_india_other}}</span></p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Do you have Director Identification Number (DIN)?</p>
	            			<p class="ans_label">{{prop_nominee.din}}  <span v-if="prop_nominee.din=='no'">{{prop_nominee.din_other}}</span></p>
		                </div>
					</div>
		        </div>
		        <div v-if="activetab ==='3'" class="tabcontent">
		        	<div class="col-md-12 p-l-r-0 f-left">
						<div class="form-group col-md-6  f-left">
							<p class="qustion_label">Website (if available)</p>
	            			<p class="ans_label">{{prop_others.website}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-12  f-left">
							<p class="qustion_label">    Please add a brief note about your business objective. </p>
	            			<p class="ans_label">{{prop_others.brief_note}}</p>
		                </div>
		            </div>
		            <div class="col-md-12 p-l-r-0 f-left form-group">
		            	<p class="qustion_label" >Proposed OPC Name</p>
		                <div class=" col-md-6 p-l-r-0 f-left">
							
	            			<p class="ans_label">{{prop_others.proposed_company_name_option1}}</p>
		                </div>
		                <div class="col-md-6 p-r-0 f-left">
	            			<p class="ans_label">{{prop_others.proposed_company_name_option2}}</p>
		                </div>
					</div>
					
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Authorised Capital</p>
	            			<p class="ans_label">{{prop_others.authorized_capital}}</p>
		                </div>
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Paid Up Capital</p>
	            			<p class="ans_label">{{prop_others.paid_up_capital}}</p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Registered office address of OPC</p>
	            			<p class="ans_label">{{prop_others.registered_office}}</p>
		                </div>
					</div>
					<div class="col-md-12 p-l-r-0 f-left upload_document" style="display: none">
		                <div class="form-group col-md-6  f-left">
							<p class="qustion_label">Upload Documents</p>
	            			<p class="ans_label">Documents.pdf <span><a href="#"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
	            			<p class="ans_label">Documents.pdf <span><a href="#"><img src="../assets/download_icon.png" style="width: auto;"></a></span></p>
		                </div>
		                
					</div>
		        </div>
		    </div>
		  
		</div>
	</div>
</template>

<script>
export default {
    name:'opc_form_preview',
	props: ['prop_owners', 'prop_others','prop_nominee'],
     watch:{
       
    },
    data() {
        return {
        	activetab: '1'
        }
    },
    methods: {

    }
};

</script>